<template>
  <div>

    <base-header class="pb-6 pb-7 pt-5 pt-md-7 bg-gradient">
      <h2 class="pb-4">Статистика</h2>
      <!-- Card stats -->
      <b-row>
        <!-- Total Cards Balance Card -->
        <b-col xl="6" md="6">
          <stats-card title="Общий баланс карт"
                      type="gradient-success"
                      :sub-title="stats.cards_balance + ' UZS'"
                      class="mb-4">
            <template slot="footer">
              <span class="text-nowrap">Всего активных карт: {{stats.total_cards_count}}</span>
            </template>
          </stats-card>
        </b-col>

        <b-col xl="3" md="6">
          <stats-card title="Переводы P2P"
                      type="gradient-red"
                      :sub-title="stats.sent_amount_today + ' UZS'"
                      class="mb-4">

            <template slot="footer">
              <span class="text-nowrap">За сегодня</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Получение"
                      type="gradient-orange"
                      :sub-title="stats.recevied_amount_today + ' UZS'"
                      class="mb-4">

            <template slot="footer">
              <span class="text-nowrap">За сегодня</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Переводы P2P"
                      type="gradient-orange"
                      :sub-title="stats.sent_amount_month + ' UZS'"
                      class="mb-4">

            <template slot="footer">
              <span class="text-nowrap">За месяц</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Получение"
                      type="gradient-orange"
                      :sub-title="stats.recevied_amount_month + ' UZS'"
                      class="mb-4">

            <template slot="footer">
              <span class="text-nowrap">За месяц</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>


  </div>
</template>
<script>
// Charts
import * as chartConfigs from '@/components/Charts/config';
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';

// Components
import BaseProgress from '@/components/BaseProgress';
import StatsCard from '@/components/Cards/StatsCard';

// Tables
import SocialTrafficTable from './Dashboard/SocialTrafficTable';
import PageVisitsTable from './Dashboard/PageVisitsTable';

import axios from "axios"

export default {
  components: {
    LineChart,
    BarChart,
    BaseProgress,
    StatsCard,
    PageVisitsTable,
    SocialTrafficTable
  },
  data() {
    return {
      stats: {
        cards_balance: '-',
        total_cards_count: 0,
        sent_amount_today: '-',
        recevied_amount_today: '-',
        sent_amount_month: '-',
        recevied_amount_month: '-'
      },
      cards: {
        rcards: [],
        scards: []
      },
      bigLineChart: {
        allData: [
          [0, 20, 10, 30, 15, 40, 20, 60, 60],
          [0, 20, 5, 25, 10, 30, 15, 40, 40]
        ],
        activeIndex: 0,
        chartData: {
          datasets: [
            {
              label: 'Performance',
              data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
            }
          ],
          labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
      redBarChart: {
        chartData: {
          labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          datasets: [{
            label: 'Sales',
            data: [25, 20, 30, 22, 17, 29]
          }]
        },
        extraOptions: chartConfigs.blueChartOptions
      }
    };
  },
  methods: {
    async getStats() {
      const response = await axios.get('dashboard/stats')
      this.stats.sent_amount_today = response.data.stats.sent_amount_today;
      this.stats.recevied_amount_today = response.data.stats.recevied_amount_today;
      this.stats.sent_amount_month = response.data.stats.sent_amount_month;
      this.stats.recevied_amount_month = response.data.stats.recevied_amount_month;
    },

    async fetchCards() {
      try {
        // Fetch reception cards
        const rCardsResponse = await axios.get('dashboard/r-cards');
        this.cards.rcards = rCardsResponse.data.cards || [];

        // Fetch P2P cards
        const sCardsResponse = await axios.get('dashboard/s-cards');
        this.cards.scards = sCardsResponse.data.cards || [];

        // Calculate total cards count
        this.stats.total_cards_count = this.cards.rcards.length + this.cards.scards.length;

        // Display total balance if it's directly available in the API response
        if (sCardsResponse.data.total_balance) {
          this.stats.cards_balance = sCardsResponse.data.total_balance;
        } else {
          // If not available directly, check if there's a balance field in the response
          this.getTotalBalanceFromCards();
        }
      } catch (error) {
        console.error('Error fetching cards data:', error);
      }
    },

    getTotalBalanceFromCards() {
      // Try to find a card that has balance information to use as a template
      const sCardWithBalance = this.cards.scards.find(card => card.balance);

      if (sCardWithBalance && sCardWithBalance.balance) {
        // Just use the balance directly as it comes from the API
        this.stats.cards_balance = sCardWithBalance.balance;
      } else {
        // Fallback if no card has balance information
        this.stats.cards_balance = "0";
      }
    },

    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            label: 'Performance',
            data: this.bigLineChart.allData[index]
          }
        ],
        labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      };
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    }
  },
  mounted() {
    this.getStats();
    this.fetchCards();
    this.initBigChart(0);
  }
};
</script>
<style>
h2 {
  color: #fff;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
}

.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}

.bg-gradient {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important
}
</style>
